import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Icon from '@amzn/meridian/icon';
import chevronUpLargeTokens from '@amzn/meridian-tokens/base/icon/chevron-up-large';
import chevronDownLargeTokens from '@amzn/meridian-tokens/base/icon/chevron-down-large';
import { Link, SectionDivider } from 'src/common/styled';
import { useOffRampToAmazon } from 'src/hooks/useOffRampToAmazon';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
export const ControlledExpander = ({ title, open, children, id }) => {
    const [isOpen, setOpen] = React.useState(open);
    const onExpanderClick = () => {
        setOpen(!isOpen);
    };
    return (_jsxs("div", { id: id, children: [_jsx(SectionDivider, {}), _jsxs(Column, { spacingInset: "400 350", spacing: "300", children: [_jsx("div", { onClick: onExpanderClick, "data-testid": id, children: _jsxs(Row, { widths: ['fill', 'fit'], alignmentHorizontal: "justify", children: [_jsx(Text, { type: "b400", children: _jsx("b", { children: title }) }), _jsx(Row, { alignmentHorizontal: "end", children: _jsx(Icon, { tokens: isOpen ? chevronUpLargeTokens : chevronDownLargeTokens, color: "primary" }) })] }) }), isOpen && children] })] }));
};
/**
 * Converted from:
 *  - https://tiny.amazon.com/1d5xw6ssc/HandshakePainterComponents/8d138c8d/Description.kata
 *  - https://tiny.amazon.com/agfti869/HandshakePainterComponents/8d138c8d/ReturnPolicy.kata
 *  - https://tiny.amazon.com/bmj8mdrv/HandshakePainterComponents/8d138c8d/PriceHidden.kata
 *
 * TODO:
 *  - Weblab and item-selector logic: https://tiny.amazon.com/mxfnp2jf/HandshakePainterAssets/mainline/detail-page.js#L32-L40
 */
export const ExpanderSection = ({ description, returnPolicyUrl, shouldHidePrice }) => {
    const [bundle, isLoading] = useBundle('pages.productDetails');
    const offRampToAmazon = useOffRampToAmazon();
    const primaryContent = description.slice(0, 3);
    const secondaryContent = description.slice(3, description.length);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const onSecondaryContentClick = () => {
        setIsExpanded(!isExpanded);
    };
    const openExternalLink = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        offRampToAmazon(url, ReportActionSource.ReturnPolicy);
    };
    if (isLoading)
        return null;
    return (_jsxs(_Fragment, { children: [description.length > 0 && (_jsxs(ControlledExpander, { open: true, title: bundle.getMessage('description'), id: "description-expander", children: [_jsxs(Text, { breakWord: true, tag: "ul", children: [primaryContent.map((bullet) => (_jsx("li", { children: bullet }, bullet))), isExpanded && secondaryContent.map((bullet) => _jsx("li", { children: bullet }, bullet))] }), secondaryContent.length > 0 && (_jsx(Text, { type: "b300", children: _jsx(Link, { role: "button", "data-testid": "secondary-content-expander", underline: true, onClick: onSecondaryContentClick, children: bundle.getMessage(isExpanded ? 'viewLess' : 'viewMore') }) }))] })), _jsx(ControlledExpander, { open: false, title: bundle.getMessage('returnPolicy'), id: "return-policy-expander", children: _jsx(Text, { type: "b300", children: bundle.formatMessage('returnPolicyContent', {
                        a: (chunk) => (_jsx(Link, { underline: true, onClick: openExternalLink, href: returnPolicyUrl, children: chunk }, returnPolicyUrl)),
                        // Weblab T1 has the spans
                        span1: (chunk) => (_jsx("span", { className: "item-selector-1", children: chunk }, "item-selector-1")),
                        span2: (chunk) => (_jsx("span", { className: "item-selector-2", children: chunk }, "item-selector-2")),
                    }) }) }), shouldHidePrice && (_jsx(ControlledExpander, { open: false, title: bundle.getMessage('priceHidden'), id: "price-hidden-expander", children: _jsx(Text, { children: bundle.getMessage('priceHiddenContent') }) }))] }));
};
